// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1763":"1ae57903","2741":"8f15b9f2","6379":"1ae57903","9588":"1ae57903"}[chunkId] + ".chunk.css";
};